import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import NorthStarGuideBlock from "./blocks/NorthStarGuideBlock";
import { SPIKING_GUIDE_ROUTE } from "./SpikingSignsBadge";
import { MomentButton } from "../radio/MomentLink";

const STATIC_BLOCK = { block_id: "static-north-star", type: "north_star_guide", config: {} };
export { STARFLOWER_LOGO, StarPathMark } from "./StarPathMark";
import { StarPathMark } from "./StarPathMark";

// Full North Star spiking card (same as First Star Entertainment) — placed under the splash of every static page.
export const NorthStarSection = ({ className = "", containerClass }) => (
  <div className={className} data-testid="north-star-section">
    <NorthStarGuideBlock block={STATIC_BLOCK} layoutKey="static" containerClass={containerClass} />
  </div>
);

// Compact strip — home page, and the small North Star box under the top of pages that don't carry the full card.
export const NorthStarStrip = ({ prefix = "home" }) => (
  <div className="mb-6 rounded-2xl border-2 border-[#1D4ED8]/30 bg-white px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 shadow-[0_14px_40px_-22px_rgba(29,78,216,0.45)]" data-testid={`${prefix}-north-star-strip`}>
    <div className="flex items-start gap-2.5 text-sm md:text-base font-extrabold uppercase tracking-[0.14em] leading-snug text-[#1D4ED8] flex-1" data-testid={`${prefix}-north-star-eyebrow`}>
      <ShieldAlert className="h-5 w-5 shrink-0 mt-0.5" />
      <span>Food &amp; Drink Spiking</span>
    </div>
    <MomentButton momentKey="spiking-overview" testId={`${prefix}-spiking-moment`} />
    <Link to={SPIKING_GUIDE_ROUTE} className="inline-flex items-center justify-center rounded-full bg-[#1D4ED8] hover:bg-[#1e40af] text-white px-6 py-2.5 text-sm md:text-base font-extrabold uppercase tracking-wide whitespace-nowrap transition-colors" data-testid={`${prefix}-know-the-signs-btn`}><StarPathMark className="h-6 w-6 mr-2" /> Know the signs</Link>
  </div>
);

export const NorthStarBox = ({ prefix, className = "" }) => (
  <div className={className} data-testid="north-star-box"><NorthStarStrip prefix={prefix} /></div>
);

export default NorthStarSection;
